import { createRootRoute, Outlet, Link } from '@tanstack/react-router';
import { UpdateToast } from '../components/UpdateToast';

function NotFound() {
  return (
    <div className="min-h-[100dvh] flex items-center justify-center px-6">
      <div className="text-center">
        <h1 className="text-title">Page not found</h1>
        <Link to="/admin" className="mt-4 inline-block font-semibold text-royal underline">
          Go to the admin panel
        </Link>
      </div>
    </div>
  );
}

export const Route = createRootRoute({
  component: () => (
    <>
      <Outlet />
      <UpdateToast />
    </>
  ),
  notFoundComponent: NotFound,
});
